//
//
//
//
//
//
var script = {
  name: 'Eye_close_16'
};

export default script;
